module.exports = __webpack_public_path__ + "media/application/images/2021/consumer-red-b7f240beae3d5c3c38c3cfb37f438b94.svg";